import { type ReactElement } from 'react';
import {
  skeletonBarStyle,
  skeletonContainerStyle,
  skeletonHeaderStyle,
  skeletonRowStyle,
} from '@/containers/PlanOfStudy/plans-of-study.styles';

export interface TableSkeletonProps {
  columns: readonly string[];
  rowCount?: number;
  testId?: string;
  ariaLabel?: string;
}

export function TableSkeleton({
  columns,
  rowCount = 12,
  testId,
  ariaLabel,
}: TableSkeletonProps): ReactElement {
  return (
    <div
      style={skeletonContainerStyle}
      data-testid={testId}
      {...(ariaLabel ? { 'aria-busy': true, 'aria-label': ariaLabel } : {})}
    >
      <div style={skeletonHeaderStyle}>
        {columns.map((width, index) => (
          <div key={`table-skeleton-header-${index}`} style={skeletonBarStyle(width)} />
        ))}
      </div>
      {Array.from({ length: rowCount }, (_, rowIndex) => (
        <div key={`table-skeleton-row-${rowIndex}`} style={skeletonRowStyle}>
          {columns.map((width, colIndex) => (
            <div
              key={`table-skeleton-cell-${rowIndex}-${colIndex}`}
              style={skeletonBarStyle(width)}
            />
          ))}
        </div>
      ))}
    </div>
  );
}
